import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";
import { clearOfflineData, cacheUser, cachedUser } from "@/lib/offline";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);

  const refreshUser = useCallback(async () => {
    try {
      const { data } = await api.get("/auth/me");
      setUser(data);
      cacheUser(data);
    } catch (e) {
      setUser((!e?.response && cachedUser()) || false);
    }
  }, []);

  useEffect(() => { localStorage.removeItem("vv_token"); refreshUser(); }, [refreshUser]);

  const authenticate = async (path, body) => {
    const { data } = await api.post(path, body);
    cacheUser(data.user);
    setUser(data.user);
    return data.user;
  };

  const logout = async () => {
    await api.post("/auth/logout").catch(() => {});
    clearOfflineData();
    setUser(false);
  };

  return (
    <AuthContext.Provider value={{ user, setUser, refreshUser, logout,
      login: (b) => authenticate("/auth/login", b), register: (b) => authenticate("/auth/register", b) }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
